import EN from './EN';

export default EN;
